<template>
  <div
    style="
      background-size: cover;
      background-image: url('../../assets/img/bgLogin.png');
    "
    :style="{ backgroundImage: `url(${backgroundBanners})` }"
    class="c-app m-0 align-items-center"
  >
    <CContainer>
         <CButton color="link" class="px-0 text-left" :href="'Login'"
        >Back to Login</CButton
      >
      <CCol sm="12" lg="12" class="mt-2 text-center">
       
        <div v-if="ErrorMessage == true" class="">
          <CAlert show color="danger">
            <strong class="text-danger mr-2"
              >Wrong Code
            </strong>
          </CAlert>
        </div>
        <div v-if="SuccessMessage == true" class="">
          <CAlert show color="success">Successfully to Reset Password</CAlert>
        </div>
      </CCol>

      <CCard class="custom-card m-0">
        <CRow>
          <CCol sm="12" class="justify-content-center m-0">
            <CRow class="p-2">
              <CCol sm="6" lg="6">
                <div class="text-center">
                  <img style="width: 80px" src="../../assets/img/Logo.png" />
                  <h4 class="mt-2">Forgot Password !</h4>
                  <p class="text-muted">
                    Enter your email address below and we will you send a secret
                    number to reset your password(within 2 minutes) <br />
                  </p>
                </div>

                <CCol sm="12" lg="12" class="justify-content-center">
                  <CRow>
                    <CCol sm="12" lg="12" class="p-2">
                      <CRow>
                        <CCol sm="12" lg="12">
                          <CRow class="d-flex">
                            <CCol sm="12" class="mt-2">
                              <div v-if="hideemail == true">
                             
                              </div>
                              <div v-else>
                                 Email
                              <CInput
                                type="text"
                                v-model="userEmail"
                                placeholder="Enter your Email"
                              />
                              <div v-if="SubmittedForm === true">
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="ResetPassword"
                                  block
                                  disabled
                                  >Resetting</CButton
                                >
                              </div>
                              <div v-else>
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="Forgot"
                                  block
                                  >Reset Password</CButton
                                >
                              </div>
                              </div>
                              <br />
                              <div v-if="verify == true">
                                <CCard class="p-3">
                                  We've sent verification code to your email
                                  <br />
                                  <br />
                                  <CInput
                                    type="text"
                                    v-model="code"
                                    placeholder="Enter your verification code"
                                  />
                                  <br />
                                    <div v-if="VerifiedForm === true">
                                  <CButton
                                    color="success"
                                    class="custom-btn"
                                    type="submit"
                                    @click="ValidateCode"
                                    block
                                    disabled
                                    >Verified code</CButton
                                  >
                                    </div>
                                    <div v-else>
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="ValidateCode"
                                  block
                                  >Verify Password</CButton
                                >
                              </div>
                                </CCard>
                              </div>

                               <div v-if="change == true">
                                <CCard class="p-3">
                                  New Password
                                  <br /> <br />
                                  Enter your new password for your account to replace the old password
                                  <CInput
                                    type="password"
                                    v-model="newPassword"
                                    placeholder="Enter your password"
                                  />
                                  <CButton
                                    color="success"
                                    class="custom-btn"
                                    type="submit"
                                    @click="ChangePassword"
                                    block
                                    >New Password</CButton
                                  >
                                </CCard>
                              </div>
                            </CCol>
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </CCol>
              </CCol>
              <CCol sm="6" lg="6">
                <CCard
                   style="border-radius: 20px;background: cornflowerblue;margin-bottom: 0px;"
                  class="text-center text-white"
                  body-wrapper
                >
                  <CCardBody>
                    <h2>Forgot Password for Tutor</h2>
                    <p>
                      Pickiddo is a platform to manage online tuition by
                      providing on-demand tuition services.
                    </p>
                    <img
                      style="max-width: 100%"
                      src="../../assets/img/forgot.png"
                    />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundBanner from "../../assets/img/bgApps.jpg";
export default {
  name: "Login",
  data() {
    return {
        backgroundBanner,
      findtutors: [],
      teachers: [],
      Busy: false,
      status: false,

      SelectedFindTutor: "",
      SelectedTeacher: "",

      ErrorMessage: false,
      SuccessMessage: false,
      verify: false,
      SubmittedForm: false,
      VerifiedForm: false,
      change: false,
      hideemail: false,

      userEmail: "",
      code: "",
      newPassword: "",
    };
  },
  async mounted() {},
  methods: {
    Forgot() {
      this.SubmittedForm = true;
      this.verify = true;
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);

      return this.$API
        .post(this.$ForgotPassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
          } else {
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

          }
        });
    },
    ValidateCode() {
      this.SubmittedForm = true;
      this.VerifiedForm = true;
      this.verify = true;
      
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);
       formData.append("code", this.code);

      return this.$API
        .post(this.$ValidateForgotPasswordCode, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.change = true;
            this.hideemail = true;
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
    ChangePassword() {
      this.SubmittedForm = true;
       this.hideemail = true;
        this.VerifiedForm = true;
      this.verify = true;
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);
       formData.append("code", this.code);
        formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
            this.SuccessMessage = true;
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
  },
};
</script>
<style scoped>
.col-centered {
  float: none;
  margin: 0 auto;
}
</style>
